import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { ETAPaymentMethod } from '~/api/ETA';
import { checkoutStore } from '~/stores';

import styles from './MobileMoneyPayment.module.scss';

const PHONE_MAX_LENGTH = 9;

export const MobileMoneyPayment: React.FC = observer(() => {
  const { t } = useTranslation();

  const isAirtel =
    checkoutStore.activePaymentMethod === ETAPaymentMethod.PhoneAirtel;
  const prefix = isAirtel ? '07' : '06';
  const value = checkoutStore.mobileMoneyPhoneVal;
  const phoneValid =
    value.length === PHONE_MAX_LENGTH && value.startsWith(prefix);

  return (
    <div className={styles.mobileMoneyPayment}>
      <h3 className={styles.title}>
        {t('mobileMoneyPaymentTitle', {
          operator: isAirtel ? 'Airtel' : 'Moov',
        })}
      </h3>
      <label
        className={classes([
          styles.inputField,
          {
            [styles.inputFieldInvalid!]: !!value && !phoneValid,
            [styles.inputFieldValid!]: !!value && phoneValid,
          },
        ])}
      >
        <input
          type="tel"
          data-input="mobile-money-phone"
          className={styles.input}
          placeholder={isAirtel ? '07 XXX XXXX' : '06 XXX XXXX'}
          value={value}
          onChange={(e) => {
            const digits = e.target.value.replace(/\D/g, '');
            if (digits.length <= PHONE_MAX_LENGTH) {
              checkoutStore.setMobileMoneyPhoneVal(digits);
            }
          }}
          autoFocus={true}
          maxLength={PHONE_MAX_LENGTH}
        />
      </label>
      <p className={styles.subtitle}>{t('mobileMoneyPaymentDescription')}</p>
    </div>
  );
});

export default MobileMoneyPayment;
